import { Transition } from '@studiometa/ui';
import { untrapFocus, trapFocus } from '@studiometa/js-toolkit/utils';

export default class CompleteProductPanel extends Transition {
    
    static config = {
        name: 'CompleteProductPanel',
        refs: ['close[]'],
    };
    
    isOpen = false;
    
    
    /**
    * Focus trap when CompleteProductPanel is open
    * @param {boolean} ESC Will be true if the key initiating the event is the esc key.
    */
    keyed({ event, isDown, isUp, ESC }) {
        if (!this.isOpen) {
            return;
        }
        
        if (isDown) {
            trapFocus(document.body, event);
        }
        
        if (ESC && isUp) {
            this.close();
        }
    }
    
    /**
    * onCloseClick
    */
    onCloseClick() {
        this.close();
    }
    
    /**
    * open fn
    */
    open() {
        document.addEventListener('keyup', (event) => {
            trapFocus(this.$el, event);
        });
        this.isOpen = true;
        this.enter();
        document.body.classList.add('!tw-overflow-hidden');
        this.$el.setAttribute('aria-hidden', 'false');
        this.$el.removeAttribute('inert');
    }
    
    /**
    * close fn
    */
    close() {
        untrapFocus();
        this.isOpen = false;
        this.leave();
        document.body.classList.remove('!tw-overflow-hidden');
        this.$el.setAttribute('aria-hidden', 'true');
        this.$el.setAttribute('inert', '');
    }
}
